import { cellRenderParseData } from '../../utils/functions';
import { cellRenderPopupAct } from '../PopupActMVP/functionPopupAct';

/** Список полей */
const columnDataGridAct = [
  {
    dataField: 'docId',
    dataType: 'string',
    caption: 'Номер акта',
    cellRender: cellRenderPopupAct
  },
  {
    dataField: 'docType',
    dataType: 'string',
    caption: 'Тип акта (описание)'
  },
  {
    dataField: 'docDate',
    dataType: 'date',
    caption: 'Дата акта',
    cellRender: cellRenderParseData
  },
  {
    dataField: 'docStatusDesc',
    dataType: 'string',
    caption: 'Статус акта (описание)'
  }
];

export default columnDataGridAct;
